<template>
  <v-app app>
    <v-content>
      <router-view/>
    </v-content>
    <v-bottom-navigation v-model="bottomNav" grow :value="true" fixed dark color="#262626" height=80>
      <v-btn exact to="/prova" color="#ffc545" text value="evaluate">
        <span class="is-uppercase is-size-7">Rösta</span>
        <v-icon>mdi-beer</v-icon>
      </v-btn>

      <v-btn exact to="/ol" color="#ffc545" text value="beers">
        <span class="is-uppercase is-size-7">Resultat</span>
        <v-icon>mdi-format-list-bulleted</v-icon>
      </v-btn>

      <v-btn exact to="/favoriter" color="#ffc545" text value="facts">
        <span class="is-uppercase is-size-7">Favoriter</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn exact to="/bryggerier" color="#ffc545" text value="breweries">
        <span class="is-uppercase is-size-7">Bryggerier</span>
        <v-icon>mdi-factory</v-icon>
      </v-btn>

      <v-btn exact to="/nytt-prov" color="#ffc545" text value="addnew" class="d-none d-md-flex">
        <span class="is-uppercase is-size-7">Nytt prov</span>
        <v-icon>mdi-playlist-check</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import myMixin from './mixins'

export default {
  name: 'App',
  mixins: [myMixin],
  data () {
    return {
      bottomNav: 'evaluate'
    }
  },
  mounted () {
    this.$store.dispatch('loadRatingList')
    this.$store.dispatch('setRaterName', this.getCookie('userName'))
    this.$nextTick(() => {
      this.$store.dispatch('loadData')
    })
  }
}
</script>
<style lang="scss">
@import 'assets/styles/config.scss';
// Fix until https://github.com/vuetifyjs/vuetify/issues/8067 gets solved
.v-item-group.v-bottom-navigation .v-btn.v-size--default {
  height: inherit;
}

.v-card__title {
  word-break: break-word;
}

.v-card--link:focus::before {
  opacity: 0;
}

.theme--light .application--wrap {
  background: #fff;
  max-width: 500px;
  margin: 0 auto;
}
.subtitle {
  font-size: 1.5rem;
}
.v-input {
  &__icon {
    &--prepend-inner {
      .v-icon {
        color: rgba(0,0,0,0.1);
      }
    }
  }
}
</style>
